var map = {
	"./AgInnovationFormatted.png": 58160,
	"./BiofuelsDigest.png": 42238,
	"./CBCNews.png": 7960,
	"./CDL.png": 53384,
	"./CPP.png": 76808,
	"./FarmtarioFormatted.png": 55376,
	"./FinancialPost.png": 44176,
	"./Forbes.png": 11534,
	"./GD.png": 77594,
	"./GFOMag.png": 24160,
	"./Germination.png": 88650,
	"./JohnDeereFurrow.png": 43378,
	"./OABA.png": 86080,
	"./OntarioFarmer.png": 27102,
	"./PictonGazette.png": 8534,
	"./SaskBarley.png": 92646,
	"./SuccessfulFarming.png": 32433,
	"./countryGuide.png": 62981,
	"./farm.com.png": 3630,
	"./farmingForTomorrow.png": 13103,
	"./ff.png": 3311,
	"./foodsInCanada.png": 61555,
	"./rdNews.png": 52504,
	"./rhAccelerator.png": 73856,
	"./speaking/ANAC.png": 56199,
	"./speaking/ASA.png": 61377,
	"./speaking/Ag in Motion.png": 40299,
	"./speaking/Ag-Innovation.png": 4220,
	"./speaking/Barchart.png": 15395,
	"./speaking/CCA.png": 47687,
	"./speaking/CMBTC Crop Tour.png": 52197,
	"./speaking/Canadian Arab Business.png": 44723,
	"./speaking/E Pack Asia.png": 17122,
	"./speaking/Farm Forum Event.png": 40333,
	"./speaking/FarmJournal.png": 38205,
	"./speaking/GFO.png": 96822,
	"./speaking/Greenstone.png": 2562,
	"./speaking/KC-Fed.png": 56730,
	"./speaking/MaRS.png": 80069,
	"./speaking/Prairie Seed Talk.png": 43563,
	"./speaking/Smart Pack.png": 14432,
	"./speaking/StableViewTech.png": 74756,
	"./speaking/agri.png": 63797,
	"./speaking/bcc.png": 91332,
	"./speaking/case.png": 12322,
	"./speaking/cdl.png": 93679,
	"./speaking/emergingPrairie.jpeg": 59291,
	"./speaking/farmscom.png": 87540,
	"./speaking/grainWorld.png": 17253,
	"./speaking/grey-county.png": 28876,
	"./speaking/jonahGroup.png": 2213,
	"./speaking/oaba.png": 5561,
	"./speaking/oco.png": 29797,
	"./speaking/old_college.png": 65117,
	"./speaking/plugAndPlay.png": 27437,
	"./speaking/seedprocessors-logo.png": 85720,
	"./speaking/southWest.png": 35382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52091;